import useCasesJson from '../../../data/use-case-pages.json';
import {currentYear, replaceYearDeep} from '../replace-year';

export interface UseCaseFeature {
  title: string;
  body: string;
}

export interface UseCase {
  slug: string;
  name: string;
  category: string;
  metaTitle: string;
  metaDescription: string;
  whyItMatters: string[];
  features: UseCaseFeature[];
}

const CATEGORY_LABELS: Record<string, string> = {
  creators: 'Creators & Influencers',
  wellness: 'Health & Wellness',
  beauty: 'Beauty & Personal Care',
  ecommerce: 'E-commerce & Sellers',
  education: 'Education & Coaching',
  professional: 'Professional & Business',
  misc: 'More',
};

const useCases = replaceYearDeep(
  useCasesJson as unknown as Record<string, UseCase>,
  currentYear(),
);

export function getUseCase(slug?: string): UseCase | null {
  if (!slug) return null;
  return useCases[slug] || null;
}

export function getAllUseCases(): UseCase[] {
  return Object.values(useCases);
}

export function getCategoryLabel(category: string): string {
  return CATEGORY_LABELS[category] || category;
}

export function getUseCasesByCategory(): [string, UseCase[]][] {
  const grouped: Record<string, UseCase[]> = {};
  for (const useCase of getAllUseCases()) {
    (grouped[useCase.category] ||= []).push(useCase);
  }
  return Object.entries(grouped);
}

export function getRelatedUseCases(useCase: UseCase, limit = 4): UseCase[] {
  return getAllUseCases()
    .filter(u => u.category === useCase.category && u.slug !== useCase.slug)
    .slice(0, limit);
}
